import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: white;
  background-color: rgba(0, 150, 255, 0.44);
  border-radius: 9px;
`

const MessageIcon = styled(FontAwesomeIcon)`
  margin-right: 16px;
`

const Message = styled.p`
  font-size: 14px;
  margin: 0;
`

const MessagesFlex = styled.div`
  display: flex;
  flex-direction: column;
`

type Props = {
  messages: string[]
}

export const UserMessage: React.FC<Props> = ({ messages }) => {
  const { t } = useTranslation()
  return (
    <MessageWrapper>
      <MessageIcon icon={faInfoCircle} />
      <MessagesFlex>
        {messages.map((message, index) => (
          <Message key={index}>{t(message)}</Message>
        ))}
      </MessagesFlex>
    </MessageWrapper>
  )
}
